module.exports = __webpack_public_path__ + "static/media/covid3.7ea6107c.JPG";